exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".celebration canvas {\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1024;\n}\n.celebration .modal-dialog .close {\n  display: none;\n  font-size: 2rem;\n}\n.celebration.dismissable .modal-dialog .close {\n  display: inline-block;\n}\n.celebration .modal-body img {\n  display: block;\n  height: 300px;\n  margin: 0 auto 30px;\n}\n.celebration .modal-header {\n  border: none;\n}\n.celebration .modal-body {\n  padding: 0;\n}\n.celebration .modal-footer {\n  display: block;\n}", ""]);

// exports
